/**
 * Open trusted print HTML from the CSRP API as a real document.
 * Do not DOMPurify it: that strips style/head/script tags and leaves
 * an unstyled Times-New-Roman print page.
 */
export function openTrustedPrintHtml(html) {
  const source = String(html ?? "").trim();
  if (!source) {
    throw new Error("Server did not return print HTML");
  }

  const printWin = window.open("", "_blank");
  if (!printWin) {
    throw new Error("Pop-up blocked. Allow pop-ups to open the print view.");
  }

  printWin.document.open();
  printWin.document.write(source);
  printWin.document.close();
  try {
    printWin.focus();
  } catch {
    // ignore
  }
  return printWin;
}

export async function htmlFromPrintResponse(resp) {
  const data = resp?.data;
  if (typeof data === "string") return data;
  if (data instanceof Blob) return data.text();
  if (data instanceof ArrayBuffer) {
    return new TextDecoder("utf-8").decode(data);
  }
  return new Response(data ?? "").text();
}
